/* ===================================================================
   FYSIK "Workshop" theme — hover shot gallery
   -------------------------------------------------------------------
   Every image card behaves as if it holds several photos: hovering
   cycles through them with a cross-fade and a dot readout.

   Put pipe-separated URLs of the REAL extra photos on the container:
     <div class="pcard-media" data-shots="url-2.jpg|url-3.jpg">
   A card with no alternates simply stays still. It used to re-frame the
   single image into several crops to fake a gallery; that was removed at
   the client's request once the real photography arrived.
   =================================================================== */
/* --- Fullscreen image viewer -----------------------------------------
   Driven by any .zoom button; it opens the image sitting alongside it. */
(function () {
  var box = null, img = null, cap = null, lastFocus = null;

  function ensure() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<button class="lightbox-close" type="button" aria-label="Close">×</button>' +
      '<img alt=""><span class="lightbox-cap"></span>';
    document.body.appendChild(box);
    img = box.querySelector('img');
    cap = box.querySelector('.lightbox-cap');

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('.lightbox-close')) close();
    });
  }

  function open(src, alt) {
    ensure();
    img.src = src;
    img.alt = alt || '';
    cap.textContent = alt || '';
    box.classList.add('open');
    document.body.classList.add('lb-open');
    box.querySelector('.lightbox-close').focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('open');
    document.body.classList.remove('lb-open');
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  /* CAPTURE phase, not bubble. The card carries its own onclick that
     navigates to the product page; in the bubble phase that handler runs
     first (it is nearer the target) and the click is gone before this
     listener ever sees it. Capturing at the document lets us stop the
     event before it reaches the card at all. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.zoom');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var host = btn.closest('.card, .pcard, figure, article, section') || document;
    /* prefer whichever shot is currently showing in the hover gallery */
    var pic = host.querySelector('.shot.is-on') || host.querySelector('img');
    if (!pic) return;
    lastFocus = btn;
    open(pic.currentSrc || pic.src, pic.alt);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

(function () {
  /* Cards get the hover cross-fade only.
     Manual left/right navigation is opt-in: put data-shots-nav on the
     container. Currently that is just the KRABA kettlebell product stage —
     add the attribute elsewhere to roll it out further. */
  var TARGETS = [
    '.pcard-media',
    '.card .img-wrap',
    '.proj .bg',
    '.cat .bg',
    '.hp-card .bg',
    '[data-shots-nav]'
  ].join(',');

  var DELAY = 1100;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  function build(box) {
    if (box.dataset.shotsReady) return;
    /* Category tiles (list-collections page) show one fixed preview image --
       no hover shot-cycling and no per-frame crop/zoom. */
    if (box.closest('.cats-list')) return;
    /* Escape hatch: anything inside .static-media never cycles, whatever
       photos it has. Nothing uses it right now. */
    if (box.closest('.static-media')) return;
    /* Two ways to get the shots:
         inline  - Liquid already rendered every item as a .shot child. Used by
                   the product page, because a video cannot be expressed as a
                   url in data-shots and has to come from {{ media | video_tag }}.
         list    - cards pass sibling photo urls in data-shots and we build the
                   img tags here. */
    var inline = box.hasAttribute('data-shots-inline');
    var shots, urls = null, count, first = null;

    if (inline) {
      shots = [].slice.call(box.children).filter(function (n) {
        return n.classList && n.classList.contains('shot');
      });
      count = shots.length;
      if (count < 2) return;
      box.dataset.shotsReady = '1';
      box.classList.add('has-shots');
      if (!shots[0].classList.contains('is-on')) shots[0].classList.add('is-on');
    } else {
      first = box.querySelector('img');
      if (!first) return;

      var extra = (box.dataset.shots || '').split('|').map(function (s) {
        return s.trim();
      }).filter(Boolean);

      /* Real photos only. A card that has nothing but its one hero image now
         stays still: the old fallback re-framed that single shot into three
         crops to fake a gallery, and the client asked us to stop doing that.
         Cards get data-shots from Liquid when the product or project actually
         has more pictures. */
      /* These frames sit in the same box as the card's main photo, so they
         should be fetched the same way it is. The main photo carries a srcset
         and a sizes rule; the frames used to carry one fixed width, which is
         either too small on a retina desktop or too large on a phone -- there
         is no single number that is right for both.

         Borrowing the main image's own `sizes` keeps the two in step: change
         the card layout and both follow, with no second place to update. */
      function setResponsive(img, url, main) {
        img.src = url;
        if (!/width=\d+/.test(url)) return;
        var sizes = main && main.getAttribute('sizes');
        if (!sizes) return;
        img.srcset = [400, 600, 900, 1200, 1600].map(function (w) {
          return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
        }).join(', ');
        img.sizes = sizes;
      }

      if (!extra.length) return;
      urls = [first.getAttribute('src')].concat(extra);
      count = urls.length;
      if (count < 2) return;

      box.dataset.shotsReady = '1';
      box.classList.add('has-shots');
      first.classList.add('shot', 'is-on');
      first.setAttribute('data-frame', '0');

      /* Hold the extra frames back until the card is near the viewport.
         They are only ever seen on hover or keyboard focus -- cards do not
         cycle on their own -- so a visitor who scrolls past one never needs
         them. Building them eagerly cost roughly 400 KB on the home page for
         photographs most people never see.

         Only for cards. The product gallery (data-shots-nav) runs a separate
         low-quality-placeholder path further down that reads src directly,
         and is left exactly as it was. */
      var deferrable = !box.hasAttribute('data-shots-nav');

      shots = [first];
      for (var i = 1; i < count; i++) {
        var img = document.createElement('img');
        img.className = 'shot';
        img.loading = 'lazy';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('data-frame', '0');
        if (deferrable) {
          img.setAttribute('data-lazy-src', urls[i]);
        } else {
          setResponsive(img, urls[i], first);
        }
        box.appendChild(img);
        shots.push(img);
      }

      if (deferrable) {
        var armed = false;
        var wake = function () {
          if (armed) return;
          armed = true;
          for (var k = 1; k < shots.length; k++) {
            var u = shots[k].getAttribute('data-lazy-src');
            if (!u) continue;
            shots[k].removeAttribute('data-lazy-src');
            setResponsive(shots[k], u, first);
          }
        };

        if ('IntersectionObserver' in window) {
          /* 600px of headroom: loading starts before the card can be reached
             with a cursor, so the first hover still cross-fades instantly. */
          var io = new IntersectionObserver(function (entries) {
            for (var e = 0; e < entries.length; e++) {
              if (entries[e].isIntersecting) { io.disconnect(); wake(); return; }
            }
          }, { rootMargin: '600px 0px' });
          io.observe(box);
        } else {
          wake();
        }

        /* Registered here, before the hover handlers below, so a hover that
           somehow beats the observer still loads the frames first. */
        box.addEventListener('mouseenter', wake);
        box.addEventListener('focusin', wake);
      }
    }

    var idx = 0, timer = null, manual = false, thumbs = null;
    var withNav = box.hasAttribute('data-shots-nav');
    if (withNav) box.classList.add('has-nav');

    /* Blur-up + lazy full-res (manual galleries / PDP): swap each shot to a
       tiny blurred preview that loads instantly, then fetch the full-size
       image only for the shot being shown (and the next one). Cuts first load
       from "every shot at full width" down to one, and hides CDN latency. */
    var upgrade = null;
    if (withNav && !inline) {
      shots.forEach(function (s) {
        var full = s.getAttribute('src') || '';
        if (!/width=\d+/.test(full)) return;
        if (s.complete && s.naturalWidth > 0) return;
        s.setAttribute('data-full', full);
        s.src = full.replace(/width=\d+/, 'width=40');
        s.classList.add('lqip');
      });
      upgrade = function (i) {
        var s = shots[i];
        if (!s) return;
        var full = s.getAttribute('data-full');
        if (!full) return;
        s.removeAttribute('data-full');
        var hi = new Image();
        hi.onload = function () { s.src = full; s.classList.remove('lqip'); };
        hi.onerror = function () { s.classList.remove('lqip'); };
        hi.src = full;
      };
      upgrade(0);
    }

    var dots = document.createElement('span');
    dots.className = 'shot-dots';
    for (var d = 0; d < count; d++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      if (withNav) {
        dot.setAttribute('aria-label', 'Image ' + (d + 1) + ' of ' + count);
        bindControl(dot, d);
      } else {
        /* read-only progress indicator on cards */
        dot.disabled = true;
        dot.setAttribute('aria-hidden', 'true');
      }
      dots.appendChild(dot);
    }
    dots.firstChild.className = 'on';
    box.appendChild(dots);

    if (withNav) {
      box.appendChild(arrow('prev', '‹', 'Previous image'));
      box.appendChild(arrow('next', '›', 'Next image'));
    }

    /* Opt-in thumbnail strip (product pages): same idea as the Projects
       detail page -- pick a shot instead of stepping through with arrows.
       Sits outside the stage so it never covers the photo. */
    if (withNav && box.hasAttribute('data-shots-thumbs') && box.parentNode) {
      box.classList.add('has-thumbs');
      thumbs = document.createElement('div');
      thumbs.className = 'shot-thumbs';
      for (var t = 0; t < count; t++) {
        var tb = document.createElement('button');
        tb.type = 'button';
        tb.className = 'shot-thumb';
        tb.setAttribute('aria-label', 'Image ' + (t + 1) + ' of ' + count);
        var ti = document.createElement('img');
        ti.loading = 'lazy';
        ti.alt = '';
        ti.width = 92;
        ti.height = 92;
        var tsrc = inline
          ? (shots[t].getAttribute('data-thumb') || '')
          : urls[t];
        if (inline && shots[t].hasAttribute('data-video')) tb.classList.add('is-video');
        ti.src = /width=\d+/.test(tsrc) ? tsrc.replace(/width=\d+/, 'width=200') : tsrc;
        tb.appendChild(ti);
        bindControl(tb, t);
        thumbs.appendChild(tb);
      }
      thumbs.firstChild.className = 'shot-thumb on';
      box.parentNode.appendChild(thumbs);
    }

    function arrow(cls, glyph, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'shot-nav ' + cls;
      b.innerHTML = glyph;
      b.setAttribute('aria-label', label);
      bindControl(b, null, cls === 'next' ? 1 : -1);
      return b;
    }

    /* Cards navigate on click (an <a>, or an onclick on the <article>), so
       every control has to swallow the event before it reaches the card. */
    function bindControl(el, target, step) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        takeOver();
        show(target === null ? idx + step : target);
      });
    }

    function takeOver() {
      manual = true;
      clearInterval(timer);
      timer = null;
      box.classList.add('shots-manual');
    }

    /* Report the first play of each video once. Eight products carry a video
       and nothing recorded whether anyone watches them, so there was no way to
       judge whether filming the rest is worth it. */
    function watchVideos(stage) {
      if (!stage || !stage.querySelectorAll) return;
      [].forEach.call(stage.querySelectorAll('video'), function (v) {
        v.addEventListener('play', function () {
          if (v.dataset.fysikSeen) return;
          v.dataset.fysikSeen = '1';
          if (window.fysikTrack) {
            var h = document.querySelector('.pdp-info h1');
            window.fysikTrack('product_video_played', {
              product: h ? h.textContent.trim() : ''
            });
          }
        });
      });
    }

    /* A shot that goes off stage is only faded out, so a playing video would
       carry on -- invisible, still audible. Stop it as it leaves.
       Native <video> is what the store uses; an embedded player would need its
       own API and none are in use here. */
    function hush(el) {
      if (!el || !el.querySelectorAll) return;
      [].forEach.call(el.querySelectorAll('video'), function (v) {
        try { v.pause(); } catch (e) {}
      });
    }

    watchVideos(box);

    function show(n) {
      hush(shots[idx]);
      shots[idx].classList.remove('is-on');
      dots.children[idx].className = '';
      if (thumbs) thumbs.children[idx].className = 'shot-thumb';
      idx = (n + count) % count;
      shots[idx].classList.add('is-on');
      dots.children[idx].className = 'on';
      if (thumbs) {
        var act = thumbs.children[idx];
        act.className = 'shot-thumb on';
        /* keep the active thumb in view when the strip scrolls */
        if (act.scrollIntoView) act.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      if (upgrade) { upgrade(idx); upgrade((idx + 1) % count); }
    }

    function start() {
      if (manual || reduced) return;
      clearInterval(timer);
      timer = setInterval(function () { show(idx + 1); }, DELAY);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
      if (!manual) show(0);
    }

    if (!withNav) {
      /* cards: hover cross-fade only */
      box.addEventListener('mouseenter', start);
      box.addEventListener('mouseleave', stop);
      var focusable = box.closest('a, article, [tabindex]') || box;
      focusable.addEventListener('focusin', start);
      focusable.addEventListener('focusout', stop);
      return;
    }

    /* swipe — and suppress the host's own click when the pointer travelled */
    var startX = null, swiped = false;
    box.addEventListener('pointerdown', function (e) {
      startX = e.clientX; swiped = false;
    });
    box.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) < 30) return;
      swiped = true;
      takeOver();
      show(idx + (dx < 0 ? 1 : -1));
    });
    box.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);

    box.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      takeOver();
      show(idx + (e.key === 'ArrowRight' ? 1 : -1));
    });
  }

  function scan() {
    document.querySelectorAll(TARGETS).forEach(build);
  }

  scan();
  /* grids on collection / projects / product render after load */
  window.__shotsScan = scan;
  var mo = new MutationObserver(function () { scan(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
